module.exports = __webpack_public_path__ + "static/media/guardian-leaf-left.b4d40801.webp";